<cs-sidepanel [show]="showSidepanel"
              [name]="'photoFeedbackGallery'"
              [panelId]="'photo-feedback-gallery-panel'"
              (close)="onPanelClose()">

    <div class="pfg-header">
        <span class="pfg-title">{{ data.title || 'Photo' }}</span>
        <span class="pfg-added" *ngIf="data.addedDate"><strong>Added</strong> <span class="survey-date-format">{{ data.addedDate }}</span></span>
        <span class="pfg-download" *ngIf="data.images && data.images[currentIndex]" (click)="downloadImg(data.images[currentIndex].value)">
            <img [src]="'angularES/src/assets/icons/download.svg'" alt="Download">
        </span>
    </div>

    <div class="pfg-body">
        <div class="pfg-split" *ngIf="data.images?.length">
            <div class="pfg-img">
                <img *ngIf="data.images[currentIndex]" class="pfg-main-media" [class.pfg-signature-media]="data.isSignature" [src]="data.images[currentIndex].value">
            </div>

            <div class="pfg-thumbs">
                <img *ngFor="let img of data.images; let i = index"
                     [src]="img.value"
                     [class.active]="i === currentIndex"
                     (click)="openImage(i)">
            </div>
        </div>

        <div class="pfg-empty" *ngIf="!data.images || !data.images.length">No images to show</div>
    </div>

    <div class="pfg-footer">
        <div class="pfg-close-btn" (click)="close()">Close</div>
    </div>

</cs-sidepanel>
